export default {"src":"/_next/static/media/ua.b6047f05.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};